import DevOpsServiceLink from './DevOpsServiceLink'

export default DevOpsServiceLink
